import {
  CreateDocumentPermissionRequest,
  CreateDocumentRequest,
  DeleteDocumentPermissionRequest,
  DeleteDocumentPermissionResponse,
  DeleteDocumentRequest,
  DeleteDocumentResponse,
  DocumentListResponse,
  DocumentPermissionListResponse,
  DocumentPermissionResponse,
  DocumentResponse,
  GetDocumentRequest,
  ListDocumentPermissionsRequest,
  ListDocumentsRequest,
  PatchDocumentRequest,
  UpdateDocumentPermissionRequest,
  UpdateDocumentRequest,
} from 'src/common-services/types/document-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class DocumentClient extends BaseClient {
  listDocuments(request: ListDocumentsRequest): Promise<DocumentListResponse> {
    return this.call<DocumentListResponse>('/documents', 'GET', {
      params: { group: request.group, parent: request.parent },
    })
  }

  createDocument(request: CreateDocumentRequest): Promise<DocumentResponse> {
    return this.call<DocumentResponse>('/documents', 'POST', { data: request })
  }

  getDocument(request: GetDocumentRequest): Promise<DocumentResponse> {
    return this.call<DocumentResponse>(`/documents/${encodeURIComponent(request.id)}`, 'GET')
  }

  updateDocument(request: UpdateDocumentRequest): Promise<DocumentResponse> {
    return this.call<DocumentResponse>(`/documents/${encodeURIComponent(request.id)}`, 'POST', {
      data: request,
    })
  }

  patchDocument(request: PatchDocumentRequest): Promise<DocumentResponse> {
    return this.call<DocumentResponse>(`/documents/${encodeURIComponent(request.id)}`, 'PATCH', {
      data: request,
    })
  }

  deleteDocument(request: DeleteDocumentRequest): Promise<DeleteDocumentResponse> {
    return this.call<DeleteDocumentResponse>(`/documents/${encodeURIComponent(request.id)}`, 'DELETE')
  }

  listDocumentPermissions(request: ListDocumentPermissionsRequest): Promise<DocumentPermissionListResponse> {
    return this.call<DocumentPermissionListResponse>(
      `/documents/${encodeURIComponent(request.documentId)}/permissions`,
      'GET'
    )
  }

  createDocumentPermission(request: CreateDocumentPermissionRequest): Promise<DocumentPermissionResponse> {
    return this.call<DocumentPermissionResponse>(
      `/documents/${encodeURIComponent(request.documentId)}/permissions`,
      'POST',
      { data: request }
    )
  }

  updateDocumentPermission(request: UpdateDocumentPermissionRequest): Promise<DocumentPermissionResponse> {
    return this.call<DocumentPermissionResponse>(
      `/documents/${encodeURIComponent(request.documentId)}/permissions/${request.id}`,
      'POST',
      { data: request }
    )
  }

  deleteDocumentPermission(request: DeleteDocumentPermissionRequest): Promise<DeleteDocumentPermissionResponse> {
    return this.call<DeleteDocumentPermissionResponse>(
      `/documents/${encodeURIComponent(request.documentId)}/permissions/${request.id}`,
      'DELETE'
    )
  }
}
